import React from "react";
import { Heart } from "lucide-react";

const happyFamilies = [
    {
        id: 1,
        image:
            "https://plus.unsplash.com/premium_photo-1663099552921-01e9bf33515b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8cGFyZW50JTIwYW5kJTIwcGV0fGVufDB8fDB8fHww",
        className: "col-span-2 row-span-2",
    },
    {
        id: 2,
        image:
            "https://images.unsplash.com/photo-1629925057384-4e031bc8d049?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fHBhcmVudCUyMGFuZCUyMHBldHxlbnwwfHwwfHx8MA%3D%3D",
        className: "col-span-1 row-span-2",
    },
    {
        id: 3,
        image:
            "https://images.unsplash.com/photo-1686668108538-5c53fdcad4c6?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fHBhcmVudCUyMGFuZCUyMHBldHxlbnwwfHwwfHx8MA%3D%3D",
        className: "col-span-1 row-span-2",
    },
    {
        id: 4,
        image:
            "https://images.unsplash.com/photo-1528301725143-1ba694832e77?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8cGFyZW50JTIwYW5kJTIwcGV0fGVufDB8fDB8fHww",
        className: "col-span-1 row-span-2",
    },
    {
        id: 5,
        image:
            "https://media.istockphoto.com/id/2201802208/photo/happy-family-playing-with-golden-retriever-dog-at-home.webp?a=1&b=1&s=612x612&w=0&k=20&c=2LXtNLxzQaufDXHtoWdgNz6tV42OoN2YUXiWJDB33R8=",
        className: "col-span-1 row-span-2",
    },
    {
        id: 6,
        image:
            "https://media.istockphoto.com/id/664213368/photo/the-best-fun-in-the-sun-happens-at-the-park.webp?a=1&b=1&s=612x612&w=0&k=20&c=OKx75nrJs7RPt36RzIifJr_jSuMH295ZAId6tCPMPHQ=",
        className: "col-span-2 row-span-2",
    },
];

export const HappyParentsSection: React.FC = () => {
    return (
        <section className="w-full">
            {/* Heading */}
            <div className="mb-4">
                <div className="inline-flex items-center gap-2 bg-orange-50 px-4 py-2 rounded-full mb-4">
                    <Heart
                        size={15}
                        className="fill-iconColor text-iconColor"
                    />

                    <span className="text-sm font-semibold text-iconColor">
                        Happy Families
                    </span>
                </div>

                <h2 className="text-xl md:text-2xl font-bold text-logoHeading leading-tight">
                    Pets That Found
                    <span className="text-iconColor">
                        {" "}Their Forever Homes 🐾
                    </span>
                </h2>

                <p className="text-gray-500 mt-1 text-sm">
                    Real moments from families who welcomed adorable companions
                    into their lives.
                </p>
            </div>

            {/* Masonry Layout */}
            <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[180px] gap-5">
                {happyFamilies.map((item) => (
                    <div
                        key={item.id}
                        className={`group relative overflow-hidden rounded-[28px] ${item.className}`}
                    >
                        <img
                            src={item.image}
                            alt=""
                            className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                        />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition duration-300" />
                    </div>
                ))}
            </div>
        </section>
    );
};